import type { ReportMeasure } from "@gettactic/api";
import React from "react";
import { formatDelta, formatValue } from "@/features/reporting/lib/formatValue";
import type { UsageByMember } from "./useZoneUsage";

export interface UtilizationCellProps {
  usage?: UsageByMember;
  measure?: Pick<ReportMeasure, "kind" | "good_when">;
  isLoading?: boolean;
}

/** "42% ▲ +3 pts" for a zone or space, or a dash when there is nothing to show. */
export const UtilizationCell: React.FC<UtilizationCellProps> = ({
  usage,
  measure,
  isLoading
}) => {
  if (isLoading) {
    return <span className="text-neutral-300">…</span>;
  }
  if (!usage || !measure) {
    return <span className="text-neutral-400">—</span>;
  }
  const delta = formatDelta(measure, usage.value, usage.previous);
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="font-medium">{formatValue(measure, usage.value)}</span>
      {delta && !delta.isFlat ? (
        <span
          className={`text-[11px] ${delta.isGood ? "text-green-600" : "text-red-600"}`}
        >
          {delta.text}
        </span>
      ) : null}
    </span>
  );
};
